<template>
  <!-- 个人资料编辑 -->
  <div id="personal" class="container" >
    <el-card shadow="never" class="default_card">
      <el-tabs v-model="activeName" @tab-click="handleClick" id="resetTabs">
        <el-tab-pane label="个人资料" name="first">
          <el-row type="flex" style="flex-wrap: wrap;">
            <el-col :span="15">
              <personalInfo v-if="!editVisible" :info="userInfo"></personalInfo>
              <el-form
                v-if="editVisible"
                ref="form"
                :model="form"
                :rules="rules"
                label-width="110px"
                label-position="left"
              >
                <el-form-item label="姓名" prop="clientName">
                  <el-input v-model="form.clientName" disabled placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="身份" prop="identityType">
                  <el-select style="width: 100%" v-model="form.identityType" placeholder="请选择身份">
                    <el-option
                      v-for="item in identityOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                  <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="所在省市" prop="provinceValue">
                  <el-input v-model="form.province" disabled></el-input>
                  <!-- <el-cascader
                    placeholder="请选择所在省市"
                    style="width: 100%"
                    :options="regionData"
                    @change="handleChange"
                    v-model="form.provinceValue"
                  ></el-cascader> -->
                </el-form-item>
                <el-form-item label="所在高校" prop="collegesId" v-if="form.identityType != 2">
                  <el-select style="width: 100%" @change="changeSchool" v-model="form.collegesId"  placeholder="请选择所在高校">
                    <el-option
                      v-for="item in schoolOptions"
                      :key="item.schoolId"
                      :label="item.schoolName"
                      :value="item.schoolId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在院系" prop="facultyId" v-if="form.identityType != 2">
                  <el-select style="width: 100%" @change="changeFaculty" v-model="form.facultyId" placeholder="请选择所在院系">
                    <el-option
                      v-for="item in departOptions"
                      :key="item.schoolId"
                      :label="item.schoolName"
                      :value="item.schoolId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在校区" prop="campusId" v-if="form.identityType != 2">
                  <el-select style="width: 100%" @change="changeCampus" v-model="form.campusId" placeholder="请选择所在校区">
                    <el-option
                      v-for="item in campusOptions"
                      :key="item.schoolId"
                      :label="item.schoolName"
                      :value="item.schoolId"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="所在企业" prop="companyName" v-if="form.identityType == 2">
                  <el-input v-model="form.companyName" placeholder="请输入所在企业"></el-input>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                  <el-input v-model="form.address" placeholder="请输入详细地址"></el-input>
                </el-form-item>
              </el-form>
              <div style="text-align: center;">
                <el-button
                  type="primary"
                  style="width: 150px"
                  v-if="!editVisible"
                  @click="editData"
                >编辑资料</el-button>
                <el-button style="width: 120px" v-if="editVisible" @click="cancel()">取消</el-button>
                <el-button
                  type="primary"
                  v-if="editVisible"
                  style="width: 120px"
                  @click="saveData()"
                >保存</el-button>
              </div>
            </el-col>
            <el-col :span="9">
              <div class="userAvatar">
                <div class="avatorBox">
                  <el-image :src="imageUrl" class="user-avatar">
                    <div slot="error">
                      <img src="@/assets/img/avatar.png" class="user-avatar" />
                    </div>
                  </el-image>
                  <el-upload
                    class="avatar-uploader"
                    :action="uploadUrl"
                    :show-file-list="false"
                    :headers="headers"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforeAvatarUpload"
                  >
                    <div v-if="editVisible" class="clickAvatar">
                      <span>
                        <i class="el-icon-upload2" style="margin-right: 5px"></i>
                      </span>
                      <span>更换头像</span>
                    </div>
                  </el-upload>
                </div>
              </div>
              <div v-if="!editVisible" class="identity-button">
                <el-button type="primary" @click="toIdentityAuth">前往身份认证</el-button>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="安全设置" name="second">
          <safeSet :info="userInfo"></safeSet>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import { regionData, codeToText } from "element-china-area-data";
import { getToken,getClient } from "@/plugins/auth";
import { updateClient,schoolList, getClientCertApply } from "@/api/request";
import { validEmail , isIdentity, isIdentity_taiwan } from "@/plugins/validate";
import personalInfo from "./personalInfo";
import safeSet from "./safeSet";
export default {
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },
  components: {
    personalInfo,
    safeSet
  },
  data() {
    var validIdentity = (rule, value, callback) => {
      if (value && !isIdentity(value) && !isIdentity_taiwan(value)) {
        return callback(new Error("请输入正确的身份证号!"));
      }
      callback();
    };
    var validemail = (rule, value, callback) => {
      if (value && !validEmail(value)) {
        return callback(new Error("请输入正确的邮箱"));
      }
      callback();
    };
    return {
      regionData,
      uploadUrl: process.env.VUE_APP_BASE_API + "/file/upload",
      headers: {
        Authorization: "Bearer " + getToken()
      },
      activeName: 'first',
      schoolOptions: [],
      departOptions: [],
      campusOptions: [],
      identityOptions: [
        { value: 0, label: "学生" },
        { value: 1, label: "教职工" },
        { value: 2, label: "公司员工" }
      ],
      rules: {
        clientName: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "blur"
          },
          {
            required: true,
            max: 30,
            message: "姓名不能超过30字",
            trigger: "blur"
          }
        ],
        identityCard: [
          { required: true, trigger: "blur", message: "请输入身份证号" },
          { validator: validIdentity, trigger: "blur" }
        ],
        email: [
          { required: true, trigger: "blur", message: "请输入邮箱" },
          { validator: validemail, trigger: "blur" }
        ],
        identityType: [
          { required: true, trigger: "change", message: "请选择身份" }
        ],
        provinceValue: [
          { required: true, trigger: "change", message: "请选择所在省市" }
        ],
        collegesId: [
          { required: true, trigger: "change", message: "请选择所在高校" }
        ],
        facultyId: [
          { required: true, trigger: "change", message: "请选择所在院系" }
        ],
        companyName: [
          { required: true, trigger: "change", message: "请选择所在企业" }
        ]
      },
      form: {
        avatar: "",
        clientName: "",
        phoneNumber: "",
        email: "",
        identityType: "",
        province: "",
        provinceCode: "",
        provinceValue: [],
        colleges: "",
        collegesId: null,
        faculty: "",
        facultyId: null,
        campus: "",
        campusId: null,
        address: "",
        companyName: ""
      },
      editVisible: false,
      fileType: "JPG,JPEG,PNG",
      imageUrl: "",
      userInfo: JSON.parse(getClient()),
      certInfo: {},
    };
  },
  created() {
    this.form = this.userInfo;
    this.form.provinceValue = this.userInfo.provinceCode ? this.userInfo.provinceCode.split(",") : [];
    this.imageUrl = this.userInfo.avatar
      ? process.env.VUE_APP_FILE_API + this.userInfo.avatar
      : "@/assets/img/avatar.png";
    if(!this.userInfo.certStatus) {
        getClientCertApply(this.userInfo.clientId).then(res => {
        this.certInfo = res.data
      })
    }
  },
  methods: {
    handleClick (val) {
    },
    editData() {
      this.editVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
        this.form.provinceValue = this.form.provinceCode.split(",");
        this.getSchoolList(1)
        if(this.form.collegesId){
          //查询所在院系下拉
          schoolList({type: 2,parentId: this.form.collegesId}).then(res=> {
            this.departOptions = res.data
          })
          //查询所在校区下拉
          schoolList({type: 3,parentId: this.form.collegesId}).then(res=> {
            this.campusOptions = res.data
          })
        }
        
        
      });
    },
    handleChange(value) {
      this.form.provinceValue = value;
      this.form.provinceCode = value.toString();
      this.form.province = this.getCodeToText(value);
      this.form.faculty = ''
      this.form.facultyId = null
      this.form.campus = ''
      this.form.campusId = null
      this.form.colleges = ''
      this.form.collegesId = null
      //查询学校下拉
      this.getSchoolList(1)
    },
    //选择高校
    changeSchool (val) {
      this.form.faculty = ''
      this.form.facultyId = null
      this.form.campus = ''
      this.form.campusId = null
      this.$nextTick(()=> {
        if (val) {
        let obj = this.schoolOptions.find((item)=> item.schoolId == val)
        this.form.colleges = obj.schoolName
        //查询所在院系下拉
        schoolList({type: 2,parentId: val}).then(res=> {
          this.departOptions = res.data
        })
        this.$forceUpdate()
      }
      }) 
      
    },
    //选择院系
    changeFaculty (val) {
      this.form.campus = ''
      this.form.campusId = null
      this.$nextTick(()=> {
        if (val) {
        let obj = this.departOptions.find((item)=> item.schoolId == val)
        this.form.faculty = obj.schoolName
        //查询所在校区下拉
        schoolList({type: 3,parentId: this.form.collegesId}).then(res=> {
          this.campusOptions = res.data
        })
        this.$forceUpdate()
      }
      })
    },
    //选择校区
    changeCampus (val) {
      if (val) {
        let obj = this.campusOptions.find((item)=> item.schoolId == val)
        this.form.campus = obj.schoolName
        this.$forceUpdate()
      }
    },
    //高校下拉接口
    getSchoolList (type) {
      let obj = {
        type: 1,
        areaCode: this.form.provinceCode ? this.form.provinceCode.split(',')[0] : ''
      }
      schoolList(obj).then(res=> {
        this.schoolOptions = res.data
      })
    },
    //把区域码转成汉字
    getCodeToText(value) {
      var name = "";
      value.map(item => (name += codeToText[item] + "/"));
      return name;
    },
    saveData() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.identityType == 2) {
            this.form.colleges = null;
            this.form.faculty = null;
            this.form.campus = null;
          } else {
            this.form.companyName = null;
          }
          updateClient(this.form).then(res => {
            this.editVisible = false;
            this.$store
              .dispatch("GetInfo")
              .then(() => {})
              .catch(err => {});
          });
        }
      });
    },
    cancel() {
      this.userInfo = JSON.parse(getClient()),
      this.editVisible = false;
      
    },
    handleAvatarSuccess(res, file) {
      this.form.avatar = res.data.url;
      this.imageUrl = process.env.VUE_APP_FILE_API + res.data.url;
    },
    beforeAvatarUpload(file) {
      if (
        file.type != "image/jpeg" &&
        file.type != "image/png" &&
        file.type != "image/jpg"
      ) {
        return this.$message.error("上传头像图片只能是 JPG/PNG 格式!");
      }
      return true;
    },
    //前往身份认证
    toIdentityAuth() {
      if(!this.certInfo) {
        this.$emit('gotoPage', '1-3')
        return
      }
      if(this.userInfo.certStatus) {
        this.$message.success('您已经进行过身份认证了~')
        return
      }
      switch(this.certInfo.auditStatus) {
				case 1:
            this.$message.warning('您的身份认证申请正在审核中，请耐心等待')
					break
				case 2:
            this.$message.success('您已经进行过身份认证了~')
					break
				case 3:
            this.$message.error('您的身份认证申请未通过审核，请重新提交')
            this.$emit('gotoPage', '1-3')
					break
			}
      
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height: calc(100vh - 200px);
  background-color: #fff;
}
.userAvatar {
  width: 200px;
  height: 200px;
  background: #f4f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0px auto;
  border-radius: 10px;
  .avatorBox {
    width: 120px;
    height: 120px;
    text-align: center;
    span {
      font-size: 15px;
      cursor: pointer;
    }
  }
  img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
  }
}
.identity-button {
  width: fit-content;
  margin: 30px auto;
}
.user-avatar {
    width: 110px;
    height: 110px;
  border-radius: 50%;
}
.clickAvatar {
  margin-top: 3px;
}
.clickAvatar:hover {
  color: #4d6fff;
}
</style>